export const validaFormatoCP = (zipCode) => {
  var regex = /[0-9]{5}/g;
  return regex.test(zipCode);
};
